export * from './academic-year-abroad-deep-link-parameters.schema';
export * from './junior-camp-deep-link-parameters.schema';
export * from './optional-date.schema';
export * from './payment-deep-link-parameters.schema';
export * from './study-and-stay-deep-link-parameters.schema';
